import React, {Fragment} from "react";
import { connect } from "react-redux";

import WithOverlay from "../../../popups/withOverlayHoc";

import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookOverlayOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import LeadCapturePopupContent from "./leadCapturePopupContent";
import LeadCapturePopupBox from "./leadCapturePopupBox";
import UnlockCalculationSteps from "./unlockCalculations/unlockCalculationSteps";
import {setShowUnlockCalculations} from "../../../../actions/unlockCalculationsFunctions";
import {UserPopupContent} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";


const LeadCapturePopup = (props) => {

  const {lookOverlayOpened, setLookOverlayOpened, showUnlockCalculations, unlockCalculationsStep, setUserPopupContent,
    userPopupContent, setShowUnlockCalculations, fabricatorData, lookOverlayAction, showAssignQuotePopup} = props;

  if (lookOverlayOpened !== LOOK_OVERLAYS.leadCapture || showAssignQuotePopup) {
    return null
  }

  const closePopup = (hideOverlay, needToCloseOverlay = true) => {
    hideOverlay(() => {
      if (needToCloseOverlay) {
        setLookOverlayOpened("");
      }
      if (showUnlockCalculations) {
        setShowUnlockCalculations(false)
      }
      if (userPopupContent === UserPopupContent.terms || userPopupContent === UserPopupContent.forgot) {
        setTimeout(() => { // after popup is closed
          setUserPopupContent(UserPopupContent.register);
        }, 400)
      }
    })
  }

  let className = "look-popup look-popup--lead";
  if (showUnlockCalculations) {
    className += " animated animated--quick" + (unlockCalculationsStep === 4 ? " animate__fadeIn" : " grohe-unc--hidden-simple")
  }
  if (fabricatorData.isNhance && false) {
    className += " look-popup--lead--with-checkbox"
  }

  return (
    <WithOverlay className="look-overlay--style" popupClassName="look-popup">
      {(hideOverlay) => (
        <Fragment>
          {showUnlockCalculations ? <UnlockCalculationSteps/> : null}
          <div className={className}>
            <div className="grohe-lead">
              <LeadCapturePopupContent closePopup={(needToCloseOverlay = true) => closePopup(hideOverlay, needToCloseOverlay)}/>
              <LeadCapturePopupBox fabricatorData={fabricatorData} lookOverlayAction={lookOverlayAction}/>
            </div>
          </div>
        </Fragment>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {showAssignQuotePopup} = store.assignQuoteState;
  const {lookOverlayOpened, lookStylePopup, lookOverlayAction} = store.lookState;
  const {isMobile} = store.serverState;
  const {showUnlockCalculations, unlockCalculationsStep} = store.unlockCalculationsState;
  const {userPopupContent} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    showAssignQuotePopup,
    lookOverlayAction,
    lookOverlayOpened,
    lookStylePopup,
    isMobile,
    showUnlockCalculations,
    unlockCalculationsStep,
    userPopupContent,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
  setShowUnlockCalculations,
  setUserPopupContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopup)
